<script context="module">
  export function get_labels(year, time_modus) {
    var year_short = (year - 2000).toString();
    var ret_labels;

    if (time_modus == "monthly") {
      ret_labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    }
    if (time_modus == "quaterly") {
      ret_labels = ["Q1/" + year_short, "Q2/" + year_short, "Q3/" + year_short, "Q4/" + year_short];
    }
    if (time_modus == "biannual") {
      ret_labels = ["01-06/" + year_short, "07-12/" + year_short];
    }

    return ret_labels;
  }

  export function get_val_or_null(data, index) {
    if (index >= data.length) {
      return 0;
    }

    if (typeof data[index] == "undefined" || isNaN(data[index])) {
      return 0;
    }

    return data[index];
  }

  export function average_month_data(d) {
    let len = 0;
    var sum = 0;
    for (var i = 0; i < d.length; i++) {
      if (typeof d[i] == "undefined" || isNaN(d[i])) {
      } else {
        len = len + 1;
        sum = sum + d[i];
      }
    }

    // var sum = d.reduce((a, b) => a + b || 0, 0);

    var average = sum / len || 0;

    let ret = [];
    for (var i = 0; i < d.length; i++) {
      ret.push(average);
    }
    return ret;
  }

  export function average_month_data_only_visible_months(d) {
    let len = 0;
    var sum = 0;
    var count_visible_months = 0;
    for (var i = 0; i < d.length; i++) {
      if (typeof d[i] == "undefined" || isNaN(d[i])) {
      } else {
        len = len + 1;
        count_visible_months = count_visible_months + 1;
        sum = sum + d[i];
      }
    }

    // var sum = d.reduce((a, b) => a + b || 0, 0);

    var average = sum / len || 0;

    let ret = [];
    for (var i = 0; i < count_visible_months; i++) {
      ret.push(average);
    }
    return ret;
  }

  // export function remove_undefined_from_dict(dict){
  //   let ret_dict = {};

  //   Object.keys(liste).forEach((l) => {
  //     if(!(typeof liste[l] === 'undefined')){
  //       ret_list[l] = liste[l];
  //     }
  //   });

  //   return ret_dict;
  // }

  export function remove_undefined(liste) {
    let ret_list = {};

    Object.keys(liste).forEach((l) => {
      if (!(typeof liste[l] === "undefined")) {
        ret_list[l] = liste[l];
      }
    });

    return ret_list;
  }

  export function transform_month_data(d, time_modus, extra_info = "") {
    let ret = [];

    if (extra_info == "cost") {
      console.log("cost in transform_month_data: ", d);
    }

    // if (extra_info == 'revenue') {
    //   console.log('revenue in transform_month_data: ', d);
    // }

    if (time_modus == "monthly") {
      return d;
    }
    if (time_modus == "quaterly") {
      var x1 = get_val_or_null(d, 0) + get_val_or_null(d, 1) + get_val_or_null(d, 2);
      if (x1 != 0) {
        ret.push(x1);
      } else {
        ret.push(undefined);
      }

      var x2 = get_val_or_null(d, 3) + get_val_or_null(d, 4) + get_val_or_null(d, 5);
      if (x2 != 0) {
        ret.push(x2);
      } else {
        ret.push(undefined);
      }

      var x3 = get_val_or_null(d, 6) + get_val_or_null(d, 7) + get_val_or_null(d, 8);
      if (x3 != 0) {
        ret.push(x3);
      } else {
        ret.push(undefined);
      }

      var x4 = get_val_or_null(d, 9) + get_val_or_null(d, 10) + get_val_or_null(d, 11);
      if (x4 != 0) {
        ret.push(x4);
      } else {
        ret.push(undefined);
      }
    }
    if (time_modus == "biannual") {
      var x1 =
        get_val_or_null(d, 0) +
        get_val_or_null(d, 1) +
        get_val_or_null(d, 2) +
        get_val_or_null(d, 3) +
        get_val_or_null(d, 4) +
        get_val_or_null(d, 5);
      if (x1 != 0) {
        ret.push(x1);
      } else {
        ret.push(undefined);
      }

      var x2 =
        get_val_or_null(d, 6) +
        get_val_or_null(d, 7) +
        get_val_or_null(d, 8) +
        get_val_or_null(d, 9) +
        get_val_or_null(d, 10) +
        get_val_or_null(d, 11);
      if (x2 != 0) {
        ret.push(x2);
      } else {
        ret.push(undefined);
      }
    }

    // if (extra_info == 'cost') {
    //   console.log('RET COST in transform_month_data: ', ret);
    // }

    return ret;
  }

  export function get_last_available_value(liste) {
    var to = liste.length - 1;
    var from = 0;

    while (to >= from) {
      if (liste[to]) {
        return liste[to];
      }
      to = to - 1;
    }
    return 0;
  }

  export function get_last_available_value_target(liste, targets) {
    var to = liste.length - 1;
    var from = 0;

    while (to >= from) {
      if (liste[to]) {
        return targets[to];
      }
      to = to - 1;
    }
    return 0;
  }

  export function transform_month_data_last_value(d, time_modus) {
    let ret = [];

    if (time_modus == "monthly") {
      return d;
    }
    if (time_modus == "quaterly") {
      var tmp_1;
      if (get_val_or_null(d, 0)) {
        tmp_1 = get_val_or_null(d, 0);
      }
      if (get_val_or_null(d, 1)) {
        tmp_1 = get_val_or_null(d, 1);
      }
      if (get_val_or_null(d, 2)) {
        tmp_1 = get_val_or_null(d, 2);
      }
      ret.push(tmp_1);

      var tmp_2;
      if (get_val_or_null(d, 3)) {
        tmp_2 = get_val_or_null(d, 3);
      }
      if (get_val_or_null(d, 4)) {
        tmp_2 = get_val_or_null(d, 4);
      }
      if (get_val_or_null(d, 5)) {
        tmp_2 = get_val_or_null(d, 5);
      }
      ret.push(tmp_2);

      var tmp_3;
      if (get_val_or_null(d, 6)) {
        tmp_3 = get_val_or_null(d, 6);
      }
      if (get_val_or_null(d, 7)) {
        tmp_3 = get_val_or_null(d, 7);
      }
      if (get_val_or_null(d, 8)) {
        tmp_3 = get_val_or_null(d, 8);
      }

      ret.push(tmp_3);

      var tmp_4;
      if (get_val_or_null(d, 9)) {
        tmp_4 = get_val_or_null(d, 9);
      }
      if (get_val_or_null(d, 10)) {
        tmp_4 = get_val_or_null(d, 10);
      }
      if (get_val_or_null(d, 11)) {
        tmp_4 = get_val_or_null(d, 11);
      }
      ret.push(tmp_4);
    }
    if (time_modus == "biannual") {
      var tmp_1;

      if (get_val_or_null(d, 0)) {
        tmp_1 = get_val_or_null(d, 0);
      }
      if (get_val_or_null(d, 1)) {
        tmp_1 = get_val_or_null(d, 1);
      }
      if (get_val_or_null(d, 2)) {
        tmp_1 = get_val_or_null(d, 2);
      }
      if (get_val_or_null(d, 3)) {
        tmp_1 = get_val_or_null(d, 3);
      }
      if (get_val_or_null(d, 4)) {
        tmp_1 = get_val_or_null(d, 4);
      }
      if (get_val_or_null(d, 5)) {
        tmp_1 = get_val_or_null(d, 5);
      }

      ret.push(tmp_1);

      var tmp_2;
      if (get_val_or_null(d, 6)) {
        tmp_2 = get_val_or_null(d, 6);
      }
      if (get_val_or_null(d, 7)) {
        tmp_2 = get_val_or_null(d, 7);
      }
      if (get_val_or_null(d, 8)) {
        tmp_2 = get_val_or_null(d, 8);
      }
      if (get_val_or_null(d, 9)) {
        tmp_2 = get_val_or_null(d, 9);
      }
      if (get_val_or_null(d, 10)) {
        tmp_2 = get_val_or_null(d, 10);
      }
      if (get_val_or_null(d, 11)) {
        tmp_2 = get_val_or_null(d, 11);
      }
      ret.push(tmp_2);
    }

    return ret;
  }

  function get_number_count_not_null(data, indices) {
    var count = 0;
    indices.forEach((i) => {
      var x = get_val_or_null(data, i);
      if (x != 0) {
        count = count + 1;
      }
    });

    if (count == 0) {
      return 1;
    }
    return count;
  }

  export function transform_month_data_real_average(d, time_modus, divisor) {
    let ret = [];

    if (time_modus == "monthly") {
      // console.log('ret: ', d);
      return d;
    }
    if (time_modus == "quaterly") {
      var divisor1 = get_number_count_not_null(d, [0, 1, 2]);
      var x1 = (get_val_or_null(d, 0) + get_val_or_null(d, 1) + get_val_or_null(d, 2)) / divisor1;
      if (x1 != 0) {
        ret.push(x1);
      } else {
        ret.push(undefined);
      }
      var divisor2 = get_number_count_not_null(d, [3, 4, 5]);
      var x2 = (get_val_or_null(d, 3) + get_val_or_null(d, 4) + get_val_or_null(d, 5)) / divisor2;
      if (x2 != 0) {
        ret.push(x2);
      } else {
        ret.push(undefined);
      }
      var divisor3 = get_number_count_not_null(d, [6, 7, 8]);
      var x3 = (get_val_or_null(d, 6) + get_val_or_null(d, 7) + get_val_or_null(d, 8)) / divisor3;
      if (x3 != 0) {
        ret.push(x3);
      } else {
        ret.push(undefined);
      }
      var divisor4 = get_number_count_not_null(d, [9, 10, 11]);
      var x4 = (get_val_or_null(d, 9) + get_val_or_null(d, 10) + get_val_or_null(d, 11)) / divisor4;
      if (x4 != 0) {
        ret.push(x4);
      } else {
        ret.push(undefined);
      }
    }
    if (time_modus == "biannual") {
      var divisor1 = get_number_count_not_null(d, [0, 1, 2, 3, 4, 5]);
      var x1 =
        (get_val_or_null(d, 0) +
          get_val_or_null(d, 1) +
          get_val_or_null(d, 2) +
          get_val_or_null(d, 3) +
          get_val_or_null(d, 4) +
          get_val_or_null(d, 5)) /
        divisor1;
      if (x1 != 0) {
        ret.push(x1);
      } else {
        ret.push(undefined);
      }
      var divisor2 = get_number_count_not_null(d, [6, 7, 8, 9, 10, 11]);
      var x2 =
        (get_val_or_null(d, 6) +
          get_val_or_null(d, 7) +
          get_val_or_null(d, 8) +
          get_val_or_null(d, 9) +
          get_val_or_null(d, 10) +
          get_val_or_null(d, 11)) /
        divisor2;
      if (x2 != 0) {
        ret.push(x2);
      } else {
        ret.push(undefined);
      }
    }

    return ret;
  }

  export function transform_month_data_average(d, time_modus) {
    let ret = [];

    if (time_modus == "monthly") {
      // console.log('ret: ', d);
      return d;
    }
    if (time_modus == "quaterly") {
      var divisor1 = get_number_count_not_null(d, [0, 1, 2]);
      var x1 = (get_val_or_null(d, 0) + get_val_or_null(d, 1) + get_val_or_null(d, 2)) / divisor1;
      if (x1 != 0) {
        ret.push(x1);
      } else {
        ret.push(undefined);
      }
      var divisor2 = get_number_count_not_null(d, [3, 4, 5]);
      var x2 = (get_val_or_null(d, 3) + get_val_or_null(d, 4) + get_val_or_null(d, 5)) / divisor2;
      if (x2 != 0) {
        ret.push(x2);
      } else {
        ret.push(undefined);
      }
      var divisor3 = get_number_count_not_null(d, [6, 7, 8]);
      var x3 = (get_val_or_null(d, 6) + get_val_or_null(d, 7) + get_val_or_null(d, 8)) / divisor3;
      if (x3 != 0) {
        ret.push(x3);
      } else {
        ret.push(undefined);
      }
      var divisor4 = get_number_count_not_null(d, [9, 10, 11]);
      var x4 = (get_val_or_null(d, 9) + get_val_or_null(d, 10) + get_val_or_null(d, 11)) / divisor4;
      if (x4 != 0) {
        ret.push(x4);
      } else {
        ret.push(undefined);
      }
    }
    if (time_modus == "biannual") {
      var divisor1 = get_number_count_not_null(d, [0, 1, 2, 3, 4, 5]);
      var x1 =
        (get_val_or_null(d, 0) +
          get_val_or_null(d, 1) +
          get_val_or_null(d, 2) +
          get_val_or_null(d, 3) +
          get_val_or_null(d, 4) +
          get_val_or_null(d, 5)) /
        divisor1;
      if (x1 != 0) {
        ret.push(x1);
      } else {
        ret.push(undefined);
      }
      var divisor2 = get_number_count_not_null(d, [6, 7, 8, 9, 10, 11]);
      var x2 =
        (get_val_or_null(d, 6) +
          get_val_or_null(d, 7) +
          get_val_or_null(d, 8) +
          get_val_or_null(d, 9) +
          get_val_or_null(d, 10) +
          get_val_or_null(d, 11)) /
        divisor2;
      if (x2 != 0) {
        ret.push(x2);
      } else {
        ret.push(undefined);
      }
    }

    return ret;
  }

  export function divide_by(list, number) {
    let ret_list = [];

    list.forEach((l) => {
      ret_list.push(l / number);
    });

    return ret_list;
  }

  export function multiply_by(list, number) {
    let ret_list = [];

    list.forEach((l) => {
      ret_list.push(l * number);
    });

    return ret_list;
  }

  export function create_target_line(time_modus, month_data, target_start, target_end, von_wo = false, ohne_nachkomma = false) {
    var nr_months = Object.keys(month_data).length;
    var nr_target_needed;

    if (time_modus == "monthly") {
      nr_target_needed = nr_months % 12;
      if (!nr_target_needed) {
        nr_target_needed = 12;
      }
    }
    if (time_modus == "quaterly") {
      nr_target_needed = Math.floor(nr_months / 3) + (nr_months % 3 ? 1 : 0);
      if (!nr_target_needed) {
        nr_target_needed = 4;
      }
    }
    if (time_modus == "biannual") {
      nr_target_needed = Math.floor(nr_months / 6) + (nr_months % 6 ? 1 : 0);
      if (!nr_target_needed) {
        nr_target_needed = 2;
      }
    }

    if (von_wo == "clv") {
      if (time_modus == "monthly") {
        nr_target_needed = 12;
      }
      if (time_modus == "quaterly") {
        nr_target_needed = 4;
      }
      if (time_modus == "biannual") {
        nr_target_needed = 2;
      }
    }

    if (von_wo == "active_boli") {
      if (time_modus == "monthly") {
        nr_target_needed = 12;
      }
      if (time_modus == "quaterly") {
        nr_target_needed = 4;
      }
      if (time_modus == "biannual") {
        nr_target_needed = 2;
      }
    }

    let target_line = [];
    for (var i = 1; i <= nr_target_needed; i++) {
      var z = i * ((target_end - target_start) / nr_target_needed) + target_start;
      if (von_wo == "clv") {
        // console.log("von_wo: ", von_wo)
        // console.log("ohne_nachkomma: ", ohne_nachkomma)
      }
      if (ohne_nachkomma) {
        // console.log("kommt rein")
        // z = parseInt(z.toFixed(0) / 1000) * 1000;
        z = parseInt(z.toFixed(0));
        // console.log("z: ", z)
      }
      target_line.push(z);
    }

    return target_line;
  }

  export function messenger_get_corrected_numbers(messenger_res_grouped, months, key) {
    let ret_dict = {};
    let month_key = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1).toString() : (new Date().getMonth() + 1).toString();
    let current_key = new Date().getFullYear().toString() + "-" + month_key;

    let last_month_key_month = new Date().getMonth() < 10 ? "0" + new Date().getMonth().toString() : new Date().getMonth().toString();
    let last_month_key = new Date().getFullYear().toString() + "-" + last_month_key_month;

    months.forEach((m) => {
      ret_dict[m] = 0;
    });

    let partner_ids = Object.keys(messenger_res_grouped);

    partner_ids.forEach((p) => {
      var list_of_messenger_entries = messenger_res_grouped[p];

      months.forEach((m) => {
        if (current_key != m) {
          if (!(m in messenger_res_grouped[p])) {
            return;
          }
          if (key in messenger_res_grouped[p][m]) {
            ret_dict[m] = ret_dict[m] + messenger_res_grouped[p][m][key];
          }
        } else {
          if (!(m in messenger_res_grouped[p]) && m != current_key) {
            return;
          }

          if (!(m in messenger_res_grouped[p]) || messenger_res_grouped[p][m][key] == 0) {
            if (last_month_key in messenger_res_grouped[p]) {
              ret_dict[m] = ret_dict[m] + messenger_res_grouped[p][last_month_key];
            } else {
            }
          } else {
            if (m in messenger_res_grouped[p]) {
              ret_dict[m] = ret_dict[m] + messenger_res_grouped[p][m][key];
            } else {
            }
          }
        }
      });
    });

    return ret_dict;
  }

  export function group_messenger(messenger_res, key) {
    let messenger_grouped = {};

    let list_to_change = [];
    let index = 0;

    messenger_res.forEach((mg) => {
      var partner_id = mg[1]["partner_id"][0];
      var date_index = mg[1]["date"].substring(0, 7);

      if (!(partner_id in messenger_grouped)) {
        messenger_grouped[partner_id] = {};
      }

      messenger_grouped[partner_id][date_index] = mg[1];
    });

    return messenger_grouped;
  }
</script>
